import PermissionChecker from 'src/modules/auth/permissionChecker';
import React from 'react';
import { Navigate, RouteProps } from 'react-router-dom';

interface EmptyPermissionsRouteProps extends Omit<RouteProps, 'element'> {
  component: React.ComponentType<any>;
  currentTenant: any;
  currentUser: any;
}

function EmptyPermissionsRoute({
  component: Component,
  currentTenant,
  currentUser,
  ..._rest
}: EmptyPermissionsRouteProps) {
  const permissionChecker = new PermissionChecker(
    currentTenant,
    currentUser,
  );

  if (!permissionChecker.isAuthenticated) {
    return (
      <Navigate
        to="/auth/signin"
        replace
      />
    );
  }

  if (!permissionChecker.isEmptyPermissions) {
    return <Navigate to="/" replace />;
  }

  return <Component />;
}

export default EmptyPermissionsRoute;
